// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22pcy","select":"styles_select__2xY41"};